<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/exchangeReasons">اسباب التقبيل</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <ExchangeReasonsForm v-if="!mainLoading && checkAccess('exchange_reasons_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
            />
            <ExchangeReasonsView v-if="!mainLoading && !checkAccess('exchange_reasons_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import ExchangeReasonsForm from './form.vue';
import ExchangeReasonsView from './view.vue';

export default {
  name: 'ExchangeReasonsUpdate',
  components: {
    ExchangeReasonsForm, ExchangeReasonsView
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل: ',
      row: null,
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/exchangeReasons/retrieve/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.rowTitle += data.row.name;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
  }
}
</script>
